import { render, staticRenderFns } from "./dynamic-document-list-table-field-template.vue?vue&type=template&id=5deb0dc2&scoped=true&"
import script from "./dynamic-document-list-table-field-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-list-table-field-template.vue?vue&type=script&lang=ts&"
import style0 from "./dynamic-document-list-table-field-template.vue?vue&type=style&index=0&id=5deb0dc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5deb0dc2",
  null
  
)

export default component.exports